{
    "description": "Defines the schema for Collection.",
    "type": "object",
    "properties": {
        "libraryId": {
            "description": "The identifier of the Library that Collection belongs to",
            "minLength": 3,
            "maxLength": 64,
            "type": "string"
        },
        "id": {
            "description": "The identifier of the Collection",
            "minLength": 3,
            "maxLength": 64,
            "type": "string"
        },
        "name": {
            "description": "The name of the Collection.",
            "minLength": 1,
            "maxLength": 128,
            "type": "string"
        },
        "isDefault": {
            "description": "Specifies whether the Collection is the default one or not, each Library can have only one default Collection",
            "type": "boolean"
        },
        "orderIdx": {
            "anyOf": [
                {
                    "description": "Specifies the order of appearance of the Collection.",
                    "minLength": 0,
                    "maxLength": 64,
                    "type": "string"
                },
                {
                    "type": "null"
                }
            ]
        },
        "createdAt": {
            "description": "The timestamp the Collection was created at",
            "type": "string",
            "format": "date-time"
        },
        "modifiedAt": {
            "description": "The timestamp when the Collection was last modified at",
            "type": "string",
            "format": "date-time"
        }
    },
    "additionalProperties": false,
    "required": [
        "id",
        "isDefault",
        "libraryId",
        "name"
    ],
    "$schema": "http://json-schema.org/draft-07/schema#"
}
